import CodeMirror from 'codemirror';
import 'codemirror/lib/codemirror.css';

import { Controller } from 'stimulus';

export default class extends Controller {
  connect() {
    this.editor = CodeMirror.fromTextArea(this.element, {
      lineNumbers: true,
      mode: 'htmlmixed',
      change: () => {
        // debugger;
      }
    });

    const textarea = this.element;
    const previewSelector = this.data.get('preview-selector');
    this.editor.on('change', (editor) => this.updatePreview());
  }

  updatePreview() {
    this.editor.save();

    let content = this.element.value;
    content = content.replace(':image:', document.getElementById('imageUrl').value);
    content = content.replace(':image-original:', document.getElementById('imageOriginalUrl').value);

    document.querySelector(this.data.get('preview-selector')).innerHTML = content;
  }

  disconnect() {
    this.editor.off('change', (editor) => this.updatePreview());
  }
}
